"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _InfoLabel = _interopRequireDefault(require("../../../components/InfoLabel"));
var _isValidUrl = _interopRequireDefault(require("../../../helpers/isValidUrl"));
var _validate = _interopRequireDefault(require("./BranchedCompletionConfig/validate.js"));
var _IdentifyRespondents = _interopRequireDefault(require("./IdentifyRespondents"));
var _OtherAllowedRoles = _interopRequireDefault(require("./OtherAllowedRoles"));
var _PostSurveyConfig = _interopRequireDefault(require("./PostSurveyConfig"));
var _RepeatConfig = _interopRequireDefault(require("./RepeatConfig"));
var _RespondentConfig = _interopRequireDefault(require("./RespondentConfig"));
var _TargetResponses = _interopRequireDefault(require("./TargetResponses"));
var _TimeConfig = _interopRequireDefault(require("./TimeConfig"));
var _UrlConfig = _interopRequireDefault(require("./UrlConfig"));
var _AutoLogout = _interopRequireDefault(require("./AutoLogout"));
var _admin = require("../../../selectors/admin.js");
var _deploymentsByEndpoint = _interopRequireDefault(require("../../../queries/deploymentsByEndpoint.graphql"));
var _admin2 = require("../../../reducers/admin");
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var fields = ['allowRetake', 'anonAutoLogoutMessage', 'autoLogout', 'autoLogoutTime', 'branchedCompletionConfig', 'chainEmailFromPawn', 'chainPhoneFromPawn', 'closeOnTarget', 'closedMessage', 'closedRoster', 'closesOn', 'completedMessage', 'completionMessage', 'completionUrl', 'otherAllowedRoles', 'endpoint', 'handle', 'hash', 'individualPasscode', 'isAssignmentPlanEligible', 'isRepeated', 'knownAutoLogoutMessage', 'logoutOnCompletion', 'metricToRespondentPropertyMappings', 'name', 'open', 'opensOn', 'options', 'passcodeAssistant', 'passcodeBackground', 'passcodeBackgroundUpload', 'passcodeBackgroundColor', 'passcodeCompletionButtonText', 'passcodeLabel', 'postCompletionAction', 'recaptcha', 'repeatInterval', 'requireLogin', 'requirePass', 'respondentConfig', 'respondentSelection', 'showReviewButtonOnCompletion', 'targetResponses', 'timepoint', 'useEndpoint'];
var validate = function validate(values, props) {
  var errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = 'Name is required';
  }
  if (!values.closedMessage) {
    errors.closedMessage = 'Message is required';
  }
  if (values.passcodeLabel && values.passcodeLabel.length > 30) {
    errors.passcodeLabel = 'Please choose a shorter Passcode Label';
  }
  if (values.passcodeCompletionButtonText && values.passcodeCompletionButtonText.length > 15) {
    errors.passcodeCompletionButtonText = 'Please choose a shorter Button Label';
  }
  if (!values.completedMessage) {
    errors.completedMessage = 'Message is required';
  }
  if (!values.completionMessage) {
    errors.completionMessage = 'Message is required';
  }
  if (values.postCompletionAction === 'url' && !values.completionUrl) {
    errors.completionUrl = 'Please specify a URL';
  }
  if (values.postCompletionAction === 'branch') {
    var branchedCompletionErrors = (0, _validate["default"])(values);
    errors = Object.assign(errors, branchedCompletionErrors);
  }
  if (values.useEndpoint) {
    if (!values.endpoint) {
      errors.endpoint = 'Cannot be empty';
    } else if (!/^[A-Za-z0-9]+$/.test(values.endpoint)) {
      errors.endpoint = 'Please use letters and numbers only';
    }
  }
  if (values.respondentConfig === 'previous' && !values.respondentSelection) {
    errors.respondentSelection = 'A selection is required';
  }
  if (values.options.length === 0) {
    errors.options = 'Select at least one survey';
  }
  if (typeof values.targetResponses === 'number') {
    if (values.targetResponses <= 0) {
      errors.targetResponses = 'Target Responses must be greater than zero';
    }
  }
  if (values.completionUrl) {
    if (!(0, _isValidUrl["default"])(values.completionUrl)) {
      errors.completionUrl = 'URL is invalid';
    }
  } else if (!values.completionMessage) {
    errors.completionMessage = "You must specify a URL if you don't want to show a completion message.";
  }
  if (!values.completedMessage) {
    errors.completedMessage = 'You must set a message.';
  }
  if (!values.closedMessage) {
    errors.closedMessage = 'You must set a message.';
  }
  return errors;
};
exports.validate = validate;
var asyncValidate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
    var result, isNotUnique;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!values.endpoint) {
              _context.next = 7;
              break;
            }
            _context.next = 3;
            return _cccisdApollo.client.query({
              query: _deploymentsByEndpoint["default"],
              variables: {
                endpoint: values.endpoint
              }
            });
          case 3:
            result = _context.sent;
            isNotUnique = result.data.flows.deploymentList.length > 0 && result.data.flows.deploymentList.filter(function (d) {
              return d.hash !== values.hash;
            }).length;
            if (!isNotUnique) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", {
              endpoint: 'This endpoint is already taken.'
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function asyncValidate(_x) {
    return _ref.apply(this, arguments);
  };
}();
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "deleteCycle", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(deploymentId, newCurrentDeploymentId) {
        var _response$data;
        var response, _response$data2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.props.removeWave(deploymentId);
              case 2:
                response = _context2.sent;
                if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'error')) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 6;
                return (0, _cccisdNotification["default"])({
                  message: 'Could not delete Data Collection Wave due to following errors:',
                  type: 'danger',
                  data: response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errors,
                  duration: 0
                });
              case 6:
                _context2.next = 14;
                break;
              case 8:
                _context2.next = 10;
                return _this.props.closeModal();
              case 10:
                _context2.next = 12;
                return _this.props.setCurrentDeploymentId(newCurrentDeploymentId);
              case 12:
                _context2.next = 14;
                return (0, _cccisdNotification["default"])('Data Collection Wave deleted successfully.');
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getBulkUploadDef", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var deploymentId, response, responseBulkDef;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              deploymentId = _this.props.deploymentId;
              if (deploymentId) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.bulkupload.deploymentRespondentMetricsDef'), {
                params: {
                  deploymentId: deploymentId
                }
              });
            case 5:
              response = _context3.sent;
              responseBulkDef = (0, _get2["default"])(response, 'data.result.original.data');
              if (!responseBulkDef) {
                _context3.next = 9;
                break;
              }
              return _context3.abrupt("return", responseBulkDef);
            case 9:
              console.error('Could not retrieve bulk upload definition');
              return _context3.abrupt("return", {});
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "onSurveysChange", function (surveyHandle) {
      var options = _this.props.fields.options;
      options.onChange((0, _xor2["default"])(options.value, [surveyHandle]));
    });
    _defineProperty(_assertThisInitialized(_this), "allowMetricsUploader", function () {
      var _deployment$assignmen, _deployment$assignmen2;
      var _this$props = _this.props,
        deployment = _this$props.deployment,
        isNew = _this$props.isNew;
      var _this$props$fields = _this.props.fields,
        closedRoster = _this$props$fields.closedRoster,
        respondentConfig = _this$props$fields.respondentConfig;
      if (isNew || respondentConfig.value === 'anonymous' || respondentConfig.value === 'managed' && !closedRoster.value || !(deployment !== null && deployment !== void 0 && (_deployment$assignmen = deployment.assignment) !== null && _deployment$assignmen !== void 0 && _deployment$assignmen.groupId) || !Fortress.hasAccess('quest.view_identifiable_data', deployment === null || deployment === void 0 ? void 0 : (_deployment$assignmen2 = deployment.assignment) === null || _deployment$assignmen2 === void 0 ? void 0 : _deployment$assignmen2.groupId)) {
        return false;
      }
      return true;
    });
    _defineProperty(_assertThisInitialized(_this), "renderMetricsUploader", function () {
      var deploymentId = _this.props.deploymentId;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkUploader, {
        handle: "deploymentRespondentMetrics",
        loadDefinition: _this.getBulkUploadDef,
        deploymentId: deploymentId,
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary"
        }, "Bulk Add Respondent Metrics")
      });
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this,
        _deployment$assignmen3;
      var _this$props2 = this.props,
        assignmentId = _this$props2.assignmentId,
        deploymentId = _this$props2.deploymentId,
        deployment = _this$props2.deployment,
        deployments = _this$props2.deployments,
        handleSubmit = _this$props2.handleSubmit,
        isNew = _this$props2.isNew,
        numCompleted = _this$props2.numCompleted,
        restrictionsLevel = _this$props2.restrictionsLevel,
        submitFailed = _this$props2.submitFailed,
        submitting = _this$props2.submitting,
        surveyList = _this$props2.surveyList;
      var _this$props$fields2 = this.props.fields,
        chainEmailFromPawn = _this$props$fields2.chainEmailFromPawn,
        chainPhoneFromPawn = _this$props$fields2.chainPhoneFromPawn,
        closedRoster = _this$props$fields2.closedRoster,
        handle = _this$props$fields2.handle,
        isAssignmentPlanEligible = _this$props$fields2.isAssignmentPlanEligible,
        name = _this$props$fields2.name,
        options = _this$props$fields2.options,
        respondentConfig = _this$props$fields2.respondentConfig,
        timepoint = _this$props$fields2.timepoint,
        recaptcha = _this$props$fields2.recaptcha;
      var isSuperUser = Fortress.isSuperUser();
      var isUber = Fortress.user.acting.role.handle === 'uberadmin';
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: name,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Name",
          tooltip: "What would you like to call this Data Collection Wave?"
        })
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: timepoint,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Timepoint",
          tooltip: "A timepoint label for this Data Collection Wave (e.g., 'Spring')",
          optional: true
        })
      })), (isSuperUser || isUber) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: handle,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Handle",
          tooltip: "This is used programmatically; only set it if you know what you are doing.",
          optional: true
        })
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: options,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Surveys",
          tooltip: "Pick the surveys that the respondents will complete."
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toggleGroup
      }, surveyList.filter(function (survey) {
        return !survey.archived;
      }).map(function (survey) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: survey.surveyId
        }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
          value: options.value.includes(survey.surveyHandle),
          onChange: _this2.onSurveysChange.bind(_this2, survey.surveyHandle),
          label: survey.label
        }));
      }))), /*#__PURE__*/_react["default"].createElement(_TimeConfig["default"], {
        fields: this.props.fields
      }), isNew && /*#__PURE__*/_react["default"].createElement(_RespondentConfig["default"], {
        fields: this.props.fields
      }), (isSuperUser || isUber || restrictionsLevel === 'unlimited') && /*#__PURE__*/_react["default"].createElement(_OtherAllowedRoles["default"], {
        fields: this.props.fields,
        isNew: isNew
      }), /*#__PURE__*/_react["default"].createElement(_UrlConfig["default"], {
        fields: this.props.fields
      }), respondentConfig.value === 'anonymous' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: recaptcha
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        value: recaptcha.value,
        onChange: function onChange(e) {
          recaptcha.onChange(!recaptcha.value);
        },
        label: "Require user to complete a captcha before beginning survey"
      })), /*#__PURE__*/_react["default"].createElement(_PostSurveyConfig["default"], {
        deploymentId: Number(deploymentId),
        fields: this.props.fields,
        submitFailed: submitFailed
      }), (respondentConfig.value === 'anonymous' || respondentConfig.value === 'manual') && /*#__PURE__*/_react["default"].createElement(_AutoLogout["default"], {
        fields: this.props.fields
      }), /*#__PURE__*/_react["default"].createElement(_TargetResponses["default"], {
        fields: this.props.fields
      }), /*#__PURE__*/_react["default"].createElement(_IdentifyRespondents["default"], {
        assignmentId: Number(assignmentId),
        deploymentId: Number(deploymentId),
        fields: this.props.fields,
        numCompleted: numCompleted
      }), (isSuperUser || isUber || restrictionsLevel === 'unlimited') && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Advanced Settings"
      }, /*#__PURE__*/_react["default"].createElement(_RepeatConfig["default"], {
        fields: this.props.fields,
        isNew: isNew
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: chainEmailFromPawn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Messages: Custom Pawn Email Location",
          tooltip: "Comma-separated chain from Pawn model in Laravel to custom email (e.g., 'data, myCustomEmail')",
          optional: true
        })
      }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: chainPhoneFromPawn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Messages: Custom Pawn Phone Location",
          tooltip: "Comma-separated chain from Pawn model in Laravel to custom phone (e.g., 'data, myCustomPhone')",
          optional: true
        })
      }), respondentConfig.value === 'managed' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: closedRoster,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Closed Roster",
          tooltip: "For managed types only. Off is default. If toggled on, only pawns rostered into this deployment will be able to access (instead of all with selected role)."
        })
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        value: closedRoster.value,
        onChange: function onChange(e) {
          closedRoster.onChange(!closedRoster.value);
        }
      })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: isAssignmentPlanEligible,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Available to select in Assignment Plans",
          tooltip: "If you are using Assignment Plans, set to Yes to make this Data Collection Wave available for selection."
        })
      }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        value: isAssignmentPlanEligible.value,
        onChange: function onChange(e) {
          isAssignmentPlanEligible.onChange(!isAssignmentPlanEligible.value);
        }
      }))), (isSuperUser || isUber || restrictionsLevel !== 'basic') && Fortress.hasAccess('quest.modify_data', deployment === null || deployment === void 0 ? void 0 : (_deployment$assignmen3 = deployment.assignment) === null || _deployment$assignmen3 === void 0 ? void 0 : _deployment$assignmen3.groupId) && this.allowMetricsUploader() && /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Metrics Upload"
      }, this.renderMetricsUploader()), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].submitButtons
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        isLoading: submitting,
        onClick: handleSubmit
      }), function () {
        if (!deploymentId || !deployment) {
          return;
        }
        var isDisabled = deployment.numInProgress;
        var button = /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          disabled: isDisabled,
          "data-deployment-remove-button": deploymentId,
          className: "btn btn-danger",
          onClick: function onClick() {
            if (isDisabled) {
              return;
            }
            (0, _cccisdConfirm["default"])({
              message: 'Confirm delete?',
              description: "Are you sure you want to delete '" + deployment.label + "'?",
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(function () {
              var _deployments$;
              _this2.deleteCycle(deploymentId, (_deployments$ = deployments[0]) === null || _deployments$ === void 0 ? void 0 : _deployments$.deploymentId);
            });
          }
        }, /*#__PURE__*/_react["default"].createElement(_bin["default"], {
          spaceRight: true
        }), " Delete");
        return isDisabled ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Cannot delete a wave with respondents"
        }, button) : button;
      }()));
    }
  }]);
  return Form;
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  assignmentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  closeModal: _propTypes["default"].func,
  deploymentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  deployment: _propTypes["default"].object,
  deployments: _propTypes["default"].array,
  fields: _propTypes["default"].object,
  handleSubmit: _propTypes["default"].func,
  isNew: _propTypes["default"].bool,
  numCompleted: _propTypes["default"].number,
  setCurrentDeploymentId: _propTypes["default"].func,
  submitFailed: _propTypes["default"].bool,
  submitting: _propTypes["default"].bool,
  surveyList: _propTypes["default"].array,
  restrictionsLevel: _propTypes["default"].string,
  removeWave: _propTypes["default"].func
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    restrictionsLevel: (0, _admin.getRestrictionsLevel)(state.assignment.admin),
    deployments: (0, _admin.getCurrentAssignmentDeployments)(state.assignment.admin)
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, {
  removeWave: _admin2.removeWave,
  setCurrentDeploymentId: _admin2.setCurrentDeploymentId
})((0, _reduxForm.reduxForm)({
  form: 'CycleForm',
  fields: fields,
  validate: validate,
  asyncValidate: asyncValidate,
  asyncBlurFields: ['endpoint'],
  overwriteOnInitialValuesChange: false
})(Form));
exports["default"] = _default;